import { camposMask } from './vars'
import {
    campoCNPJCPFValidation,
    campoCNPJCPFValidationClear,
    campoCPFInput,
    campoCepInput,
    campoCnpjInput,
    radioInit,
    radioTipoPessoa,
    detectHiddenForm,
} from "./controllers";

export default function () {
    // máscaras de campos (cpf, cep, etc.)
    camposMask.cep.el.addEventListener("input", campoCepInput);
    if (camposMask.cnpj_cpf.el) {
        camposMask.cnpj_cpf.el.addEventListener("focus", campoCNPJCPFValidationClear);
        camposMask.cnpj_cpf.el.addEventListener("blur", campoCNPJCPFValidation);
    }
    if (camposMask.cpf.el) camposMask.cpf.el.addEventListener("input", campoCPFInput);
    if (camposMask.cnpj.el) camposMask.cnpj.el.addEventListener("input", campoCnpjInput);

    // seleção de pessoa física/jurídica
    radioInit()
    if (document.body.classList.contains('tpl-viewcart')) {
        window.$('input[name="tipocliente"]')
            .on('ifChecked', evt => {
                radioTipoPessoa(evt.target.value)
            })
    } else {
        document.querySelectorAll('input[name=tipocliente]')
            .forEach(radio => {
                radio.addEventListener('click', () => {
                    radioTipoPessoa(document.forms.orderfrm.elements['tipocliente'].value)
                })
            });
    }

    document.querySelectorAll('#containerExistingAccountSelect .radio-inline')
        .forEach(el => {
            el.addEventListener('click', () => {
                window.setTimeout(detectHiddenForm, 1000)
            })
        })

    if (document.querySelector('#inputNewPassword1')) {
        document.querySelector('#inputNewPassword1')
            .dispatchEvent(new InputEvent('keyup'))
        document.querySelector('#inputNewPassword2')
            .dispatchEvent(new InputEvent('keyup'))
    }
}